<template>
  <div>
    <el-table
      :data="field_list"
      size="mini"
      style="width: 100%" height="400px">
      <el-table-column
        prop="name"
        width="200"
        label="字段">
      </el-table-column>
      <el-table-column
        prop="department_name"
        label="可读">
        <template slot-scope="scope">
          <el-checkbox size="mini" icon="el-icon-delete" :value="(tableDataProps[scope.row.id]||{}).read" @change="changeInput(scope.row.id,'read',!(tableDataProps[scope.row.id]||{}).read)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        prop="department_name"
        label="可写">
        <template slot-scope="scope">
          <el-checkbox size="mini" icon="el-icon-delete" :value="(tableDataProps[scope.row.id]||{}).write" @change="changeInput(scope.row.id,'write',!(tableDataProps[scope.row.id]||{}).write)"></el-checkbox>
        </template>
      </el-table-column>
<!--      <el-table-column label="操作" width="50">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="danger" size="mini" icon="el-icon-delete" @click="delTableData(scope.$index)" circle></el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
  </div>
</template>

<script>
export default {
  name: "BpmnForm",
  props:{
    tableDataProps:{
      type:Object||Array,
      default(){
        return {};
      }
    },
    default_read:{
      type:Boolean,
      default() {
        return true;
      }
    },
    default_write:{
      type:Boolean,
      default() {
        return false;
      }
    },
  },
  inject:['getFlowData'],
  model:{
    prop:"tableDataProps",
    event:"success",
  },
  data() {
    return {
      tableData:{},
      field_list:[]
    }
  },
  mounted() {
    const that=this;
    that.onInitTable()

    let flow_data=that.getFlowData()
    let form_fields=[]
    let userNodeList=[]
    console.info("*****************")
    console.info(flow_data)
    if(flow_data.master.cache) {
      if(flow_data.master.cache.model) {
        form_fields = flow_data.master.cache.model.field_json.map(ret=>{
          return{
            id:ret.field_name,
            name:ret.field_description
          }
        })
      }
    } else {
      if(flow_data.model) {
        form_fields = flow_data.model.field_json.map(ret=>{
          return{
            id:ret.field_name,
            name:ret.field_description
          }
        })
      }
      let graphData = flow_data.sheet.graph_data;
      if (typeof graphData === 'string') {
        try {
          graphData = JSON.parse(graphData);
        } catch (e) {
          console.error('Failed to parse graph_data:', e);
          graphData = {};
        }
      }
      userNodeList = (graphData.nodes || []).filter(node => node.type === 'user').map(node => ({
        id: node.id,
        name: node.text.value
      }));
    }

    that.field_list=form_fields.concat(userNodeList);
    let fields={}

    that.field_list.map(ret=>{
      that.tableData[ret.id]={
        read:that.tableDataProps[ret.id]!==undefined? that.tableDataProps[ret.id].read:that.default_read,
        write:that.tableDataProps[ret.id]!==undefined? that.tableDataProps[ret.id].write:ret.default_write
      }
    })

  },
  watch: {
    tableDataProps:{
      deep:true,
      immediate:true,
      handler(n){
        this.onInitTable()
      }
    }
  },
  computed: {},
  methods: {
    onInitTable(){
      const that=this;
      that.tableData=that.tableDataProps
    },
    changeInput(id,name,val){
      const that=this;
      if(!that.tableData[id]){
        that.tableData[id]={};
      }
      that.tableData[id][name]=val;
      that.$emit("success",that.tableData)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.form-input{
  width: 100%;
}
.footer{
  margin: 5px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/components/BpmnForm.vue